import { render } from "./samsung.vue?vue&type=template&id=4a1c3f11&scoped=true"
import script from "./samsung.vue?vue&type=script&lang=js"
export * from "./samsung.vue?vue&type=script&lang=js"

import "./samsung.vue?vue&type=style&index=0&id=4a1c3f11&scoped=true&lang=css"

import exportComponent from "/Users/arissa/Desktop/code/portfolio/arissa-portfolio/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a1c3f11"]])

export default __exports__